import { authHeader, BASE_URL } from '@helpers/api';

export const exportService = {
    getStatus,
};

function getStatus(exportStatusId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/export/status/${exportStatusId}`, requestOptions).then(response => {
        if (!response.ok) return Promise.reject(response.status);
        return response.json();
    });
}
